import { render } from "./header_new.vue?vue&type=template&id=18ebda77"
import script from "./header_new.vue?vue&type=script&lang=js"
export * from "./header_new.vue?vue&type=script&lang=js"

import "./header_new.vue?vue&type=style&index=0&id=18ebda77&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__